module.exports = __webpack_public_path__ + "static/media/Escalier-v2.dae635dc.glb";